import { FC } from "react";
import { Panel } from "capitalrx-components-2.0/lib/general";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import { FAQDataProps } from "../FAQSection.props";
import styles from "../FAQSection.module.scss";

const FAQCardContent: FC<FAQDataProps> = ({ content, Image, id }: FAQDataProps) => {
  return (
    <Panel className={styles.FAQContent} testId={`faq-content-${id}`}>
      <Paragraph className={styles.FAQContentText} data-testid={`test__faq-content-text-${id}`}>
        {content}
      </Paragraph>
      {Image && <div className={styles.FAQImages}>{Image}</div>}
    </Panel>
  );
};

export default FAQCardContent;
